// ./PerformaceModule.jsx

import { PerformanceProvider } from './PerformanceContext';
import PerformanceManagement from './PerformanceManagement';

export const PerformanceModule = () => (
  <PerformanceProvider>
    <PerformanceManagement />
  </PerformanceProvider>
);

export default PerformanceModule